import { render, staticRenderFns } from "./InkindMatchPrint.vue?vue&type=template&id=00e0870d&"
import script from "./InkindMatchPrint.vue?vue&type=script&lang=js&"
export * from "./InkindMatchPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports